import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOkTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M18.594 6.625c.156-.156.406-.156.531 0l.906.875c.125.156.125.406 0 .531l-9.375 9.375a.36.36 0 0 1-.531 0L5.938 13.25c-.125-.156-.125-.406 0-.531l.906-.906c.125-.126.375-.126.531 0l3 3.03z"
    />
  </svg>
);
export default SvgOkTick;
